import fetchData from "../utils/HttpClient";
import TileBannerInterface from "../interfaces/main/TileBannerInterface";
import LinkExtendedInterface from "../interfaces/core/LinkExtendedInterface";
import {BannerInterface} from "../interfaces/core/BannerInterface";

const basePathPage = '/api/page'

export function mainPageData(): Promise<{
    tileBanners: TileBannerInterface[],
    switchBanners: BannerInterface[]
    topBanners: BannerInterface[]
    bottomBanners: LinkExtendedInterface[]
}> {
    return fetchData(basePathPage + '/main')
}